import React from "react";

// Fila de lista navegable (reemplaza los card-header de acordeón).
// - title: texto principal.
// - badges: [{ label, variant }] (variant: "teams" | "dates" | "arhock" | "dark").
// - accent: "zone" | "date" | "match" => borde izquierdo de color por nivel.
// - onClick: abre el detalle (drill-down).
// - onDelete: si se pasa, muestra el botón eliminar (no dispara onClick).
// - compact: fila más baja y con menos margen (listas largas, ej. equipos).
export default function NavRow({ title, badges = [], accent, compact, onClick, onDelete }) {
  return (
    <div
      className={
        "drill-row" + (accent ? " drill-row--" + accent : "") + (compact ? " drill-row--compact" : "")
      }
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick && onClick();
        }
      }}
    >
      <div className="drill-row-main">
        <span className="drill-row-title">{title}</span>
        {badges.map((b, i) => (
          <span key={i} className={"badge badge-pill my-0 badge-" + (b.variant || "arhock")} style={{ fontSize: "0.6875rem" }}>
            {b.label}
          </span>
        ))}
      </div>
      <div className="d-flex align-items-center" style={{ gap: "0.25rem" }}>
        {onDelete && (
          <button
            type="button"
            className="drill-row-delete"
            aria-label="Eliminar"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
              <path d="M10 11v6M14 11v6" />
              <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
            </svg>
          </button>
        )}
        <svg className="drill-row-chevron" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </div>
    </div>
  );
}
